import { useEffect, useRef } from "react";

export default function TraderModal({ isOpen, title, children, onClose, width = "720px" }) {
  const backdropPointerDownRef = useRef(false);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      role="presentation"
      onMouseDown={(event) => {
        backdropPointerDownRef.current = event.target === event.currentTarget;
      }}
      onClick={(event) => {
        const shouldClose = backdropPointerDownRef.current && event.target === event.currentTarget;
        backdropPointerDownRef.current = false;

        if (shouldClose) {
          onClose();
        }
      }}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15, 23, 42, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "clamp(10px, 3vw, 24px)",
        zIndex: 1200
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onMouseDown={() => {
          backdropPointerDownRef.current = false;
        }}
        onClick={(event) => event.stopPropagation()}
        style={{
          width: "min(100%, " + width + ")",
          maxHeight: "min(92vh, 920px)",
          overflowY: "auto",
          background: "#fff",
          borderRadius: "clamp(12px, 3vw, 18px)",
          boxShadow: "0 28px 80px rgba(15, 23, 42, 0.32)",
          border: "1px solid rgba(148, 163, 184, 0.28)"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            padding: "clamp(12px, 3.5vw, 18px) clamp(14px, 4vw, 22px)",
            borderBottom: "1px solid #e2e8f0",
            position: "sticky",
            top: 0,
            background: "#fff",
            zIndex: 1
          }}
        >
          <h2 style={{ margin: 0, fontSize: "clamp(18px, 4vw, 22px)" }}>{title}</h2>
          <button
            type="button"
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "28px",
              lineHeight: 1,
              cursor: "pointer",
              color: "#475569"
            }}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>
        <div style={{ padding: "clamp(14px, 4vw, 22px)" }}>{children}</div>
      </div>
    </div>
  );
}